__turbopack_context__.v({
  "content": "BuildNation-module-scss-module__2VwiCq__content",
  "cta": "BuildNation-module-scss-module__2VwiCq__cta",
  "desc": "BuildNation-module-scss-module__2VwiCq__desc",
  "heading": "BuildNation-module-scss-module__2VwiCq__heading",
  "image": "BuildNation-module-scss-module__2VwiCq__image",
  "image_wrapper": "BuildNation-module-scss-module__2VwiCq__image_wrapper",
  "lp": "BuildNation-module-scss-module__2VwiCq__lp",
  "lpWrapper": "BuildNation-module-scss-module__2VwiCq__lpWrapper",
  "root": "BuildNation-module-scss-module__2VwiCq__root",
  "smallFont": "BuildNation-module-scss-module__2VwiCq__smallFont",
  "videoWrapper": "BuildNation-module-scss-module__2VwiCq__videoWrapper",
  "wrapper": "BuildNation-module-scss-module__2VwiCq__wrapper",
});
